module.exports = __webpack_public_path__ + "img/a_cuentas_corrientes2.05c7f95e.png";